import { Divider, Grid, TextField, Typography, useMediaQuery } from '@mui/material'
import React, { useContext, useRef, useState } from 'react'
import styles from './../../../../assets/styles/componentStyles/manychatStyles/workflowFormComponents/workflowForm.module.scss'
import textStyles from './../../../../assets/styles/componentStyles/manychatStyles/instagramStepComponent.module.scss'
import { FlowBuilderContext, FlowBuilderContextPayload } from '../../../../context/flowBuilderContext'
import TemplateFormComponent from './components/templateFormComponents'
import CustomRepliesComponent from './components/customRepliesComponent'
import TriggerFormComponent from './components/triggerFormComponent'
import NewContentBlocks from './components/newContentBlocks'
import SaveVariableFormComponents from './components/saveVariableFormComponents'
import IconsColor from '../../../utility/iconsColor'
import globalStyles from '../../../../assets/styles/global.module.scss'
import CustomAPICall from './components/customAPICall'
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import { DragDropContext, Droppable, Draggable, DropResult } from 'react-beautiful-dnd';
import { WorkflowContext, WorkflowContextPayload } from '../../../../context/workflowContext'
import { isCurrentViewVersionPublished } from '../utilityFunctions'
import ChatbotException from './components/chatbotException'
import CustomVariableCondition from './components/customVariableCondition'
import WebhookConfigCompact from './components/webhookConfig/webhookConfigCompact'
import ChatbotExceptionNew from './components/chatbotExceptionNew'
import ResetVariableFormComponent from './components/resetVariableFormComponent'
import GlobalPopUp from '../../../utility/globalPopUp'
import IntentPopup from './components/intentPopup'
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import SmartDelay from "./components/smartDelay"
import IntentConfigurationPopup from './components/intentConfigurationPopup'
import { intentConfigurationPayload } from '../../../../models/axiosModel'
import { greyColor } from '../../../../utils/colors'
import { useFlowBuilderStore } from '../../../../store/flowBuilderStore'
import { ACTION_TYPE_NAME, doesAllowToConfigureIntentForActionType, getCustomVariableConditionText } from '../flowBuilderConstants'
import SaveAndRemoveContactComponent from './components/saveAndRemoveContactComponent'
import TalkToAgentComponent from './components/talkToAgentComponent'
import SendMediaComponent from './components/sendMediaComponent'
import VariableAssignmentFormComponents from './components/variableAssignmentFormComponents'
import AssignAndRemoveTagComponent from './components/assignAndRemoveTagComponent'
import CreateUpdateThreadTagPopup from '../../../../pages/ruleBasedInbox/threadInfo/components/threadTag/createUpdateThreadTagPopup'
import { useRuleBasedInboxStore } from '../../../../store/ruleBasedInboxStore'
import { useShallow } from 'zustand/react/shallow'
import ArchiveChatComponent from './components/archiveChatComponent'
import RetrieveContactComponent from './components/retrieveContactComponent'
import { isWhatsAppChannel } from '../../../../pages/ruleBasedInbox/channelConstants'
import { INSTAGRAM_ACTION_TYPES } from '../../../../pages/ruleBasedInbox/constants'

const WorkflowFormBody = () => {
    
    // const { triggerDataObject, selectedTrigger, setSelectedTrigger, selectedTriggerKeywords, setSelectedTriggerKeywords } = props
    const { triggerDataObject, selectedTrigger, setSelectedTrigger, selectedTriggerKeywords, setSelectedTriggerKeywords, selectedPointerEvent, currentActiveNodeConfig, nodes, setNodes, onChangeCurrentActiveNodeConfig, onBlurOfFallBackOfBtnVar, deleteEdgesRelatedToStepAction, edges, updateNodeStepActions, updateNodeFlow, setUpdatedEdges } = useContext(FlowBuilderContext) as FlowBuilderContextPayload
    const { currentActiveStaticWorkflow } = useContext(WorkflowContext) as WorkflowContextPayload
    const customVariableList = useFlowBuilderStore((state) => state.customVariableList)

    const bodyFormRef = useRef<HTMLDivElement>(null);

    const [flagIntentPopup, setFlagIntentPopup] = useState<boolean>(false);
    const [selectedActionIntent, setSelectedActionIntent] = useState<any>(null);
    const [selectedIntent, setSelectedIntent] = useState<intentConfigurationPayload | null>(null);

    const { flagUpdateThreadTagPopup, setFlagUpdateThreadTagPopup } = useRuleBasedInboxStore(
        useShallow((store) => ({
            flagUpdateThreadTagPopup: store.flagUpdateThreadTagPopup,
            setFlagUpdateThreadTagPopup: store.setFlagUpdateThreadTagPopup
        }))
    )

    const breakPoints = {
        smallScreen: useMediaQuery<boolean>('(max-width : 600px) and (min-width : 0px)'),
        flagTabletScreen: useMediaQuery<boolean>('(max-width : 900px) and (min-width : 600px)'),
        flagSmallScreen: useMediaQuery<boolean>('(min-width: 0px) and (max-width: 1000px)'),
        flagLaptopScreen: useMediaQuery<boolean>('(min-width: 0px) and (max-width: 1550px)')
    }

    const deploymentChannelName = currentActiveStaticWorkflow?.chatbot_channel?.channel_name;
    const isWhatsApp = isWhatsAppChannel(deploymentChannelName);

    const handleBodyTitle = (functionName: string) => {
        const functionNameLower = functionName.toLowerCase();

        switch (functionNameLower) {
            case 'trigger':
                return "If message contains"
            case 'message':
                return "Write a message you want to send"
        }
    }

    const handleSelectFunctionTrigger = (trigger: any) => {
        setSelectedTrigger(trigger)
    }

    const handleChangeTriggerKeywords = (words: string) => {
        if (words.length > 0) {
            setSelectedTriggerKeywords(words)
        }
        else {
            setSelectedTriggerKeywords("")
        }
    }

    const handleDyanmicTriggerData = (trigger: any) => {
        if ((selectedTrigger?.function_trigger_id == trigger.function_trigger_id) && trigger.function_trigger_example_options.length > 0) {
            return <Grid item>
                <Grid container direction={"column"} gap={1}>
                    <Grid item>
                        <TextField
                            placeholder='Enter a word or multiple'
                            className={textStyles.enterWordTextField}
                            value={selectedTriggerKeywords}
                            onChange={(e) => handleChangeTriggerKeywords(e.target.value)}
                        />
                    </Grid>
                    <Grid item className={textStyles.replySectionTextStyle}>
                        Use commas to separate words
                    </Grid>
                    <Grid item className={textStyles.exampleWordsTextStyle} marginBlock={"4px"}>
                        {`For Example: `}
                        {trigger.function_trigger_example_options.map((avail: any) =>
                            <span className={textStyles.exampleWordsChips} key={avail.function_trigger_example_option_id} onClick={() => setSelectedTriggerKeywords(avail.function_trigger_example_option_value)}>
                                {avail.function_trigger_example_option_value}
                            </span>
                        )}
                    </Grid>
                </Grid>

            </Grid>
        }
    }
    function getComponentByAction(actionType: string, actionData: any, stepAction: any) {
        switch (actionType) {
            case ACTION_TYPE_NAME["TEMPLATE"]:
            case ACTION_TYPE_NAME["CAROUSEL_TEMPLATE"]:
            case ACTION_TYPE_NAME["SEND_ORDER_DETAIL_TEMPLATE"]:
                return <TemplateFormComponent handleBodyTitle={handleBodyTitle} actionData={JSON.parse(JSON.stringify(actionData))} stepAction={stepAction} />
            case ACTION_TYPE_NAME["SAVE_DATA"]:
                return <SaveVariableFormComponents actionData={actionData} stepAction={stepAction} />
            case ACTION_TYPE_NAME["VARIABLE_ASSIGNMENT"]:
                return <VariableAssignmentFormComponents actionData={actionData} stepAction={stepAction} />
            case ACTION_TYPE_NAME["RESET_DATA"]: 
                return <ResetVariableFormComponent actionData={actionData} stepAction={stepAction} />
            case ACTION_TYPE_NAME["TEXT"]:
            case INSTAGRAM_ACTION_TYPES["SEND_IG_DM_TEXT"]:
                return <CustomRepliesComponent handleBodyTitle={handleBodyTitle} actionData={actionData} stepAction={stepAction} />
            case ACTION_TYPE_NAME["CUSTOM_API"]:
                return <CustomAPICall actionData={actionData} stepAction={stepAction} />
            case ACTION_TYPE_NAME["CONDITION"]: // This is just for FE & not BE. 
                return <CustomVariableCondition actionData={actionData} stepAction={stepAction} />
            case ACTION_TYPE_NAME["AWAIT_WEBHOOK"]:
                return <WebhookConfigCompact actionData={actionData} stepAction={stepAction} />
            case ACTION_TYPE_NAME["SEND_MEDIA"]:
                return <SendMediaComponent actionData={actionData} stepAction={stepAction} />
            case ACTION_TYPE_NAME["SAVE_CONTACT"]:
            case ACTION_TYPE_NAME["REMOVE_CONTACT"]:
                return <SaveAndRemoveContactComponent actionData={actionData} stepAction={stepAction} />
            case ACTION_TYPE_NAME["TALK_TO_AGENT"]:
                return <TalkToAgentComponent actionData={actionData} stepAction={stepAction} />
            case ACTION_TYPE_NAME["ASSIGN_TAG"]:
            case ACTION_TYPE_NAME["REMOVE_TAG"]:
                return <AssignAndRemoveTagComponent actionData={actionData} stepAction={stepAction} />;
            case ACTION_TYPE_NAME["ARCHIVE_CHAT"]:
                return <ArchiveChatComponent actionData={actionData} stepAction={stepAction} />
            case ACTION_TYPE_NAME["RETRIEVE_CONTACT"]:
                return <RetrieveContactComponent actionData={actionData} stepAction={stepAction} />
            default: 
                return <></>;
        }
    }

    const onDragEnd = (result: DropResult) => {
        const { source, destination, draggableId } = result;
        if (!destination) return;

        const currentNode = nodes.find((node: any) => node.id == currentActiveNodeConfig.nodeId);
        const updatedData = Array.from(currentNode.data);
        const [removed] = updatedData.splice(source.index, 1);
        updatedData.splice(destination.index, 0, removed);

        const updatedNodes = nodes.map((node: any) => {
            if (node.id === currentActiveNodeConfig.nodeId) {
                return {
                    ...node,
                    data: updatedData,
                };
            }
            return node;
        });

        const parsedData = JSON.parse(draggableId);
        onChangeCurrentActiveNodeConfig(updatedNodes, currentActiveNodeConfig, parsedData.id, parsedData.data, {
            updateType: "editActionStepOrder",
        });
        updateNodeStepActions(updatedNodes, currentActiveNodeConfig, parsedData.id, parsedData.data, {
            updateType: "editActionStepOrder",
        });
    };

    const onClickOfAddIntent = (action: any, intent?: any) => {
        if(!isCurrentViewVersionPublished(currentActiveStaticWorkflow)){
            setSelectedActionIntent(action);
            setFlagIntentPopup(true);
            if(intent){
                setSelectedIntent(intent);
            } else {
                setSelectedIntent(null);
            }
        } 
        return;
    } 

    const onClickOfCancelIntent = () => {
        setNodes((prev: any) => {
            return prev?.map((node: any) => {
                if(node?.id == selectedActionIntent?.chatbot_step_id){
                    return {
                        ...node, 
                        data: node?.data?.map((action: any) => {
                            if(action?.chatbot_step_action_id == selectedActionIntent?.chatbot_step_action_id){
                                return {
                                    ...action, 
                                    intents: selectedActionIntent?.intents,
                                }
                            }
                            return action;
                        })
                    }
                }
                return node;
            })
        }); 
        setFlagIntentPopup(false);
    }

    const deleteConfiguredIntent = (action: any, intent?: any) => { 
        if(!isCurrentViewVersionPublished(currentActiveStaticWorkflow)){
            const updatedNodes = nodes?.map((node: any) => {
                if(node?.id == action?.chatbot_step_id){
                    return {
                        ...node, 
                        data: node?.data?.map((stepAction: any) => {
                            if(stepAction?.chatbot_step_action_id == action?.chatbot_step_action_id){
                                return {
                                    ...stepAction, 
                                    intents: intent ? action?.intents?.filter((int: any) => JSON.stringify(int) != JSON.stringify(intent)) : [],
                                }
                            }
                            return stepAction;
                        })
                    }
                }
                return node;
            });
    
            setNodes(updatedNodes);
            onBlurOfFallBackOfBtnVar(updatedNodes, currentActiveNodeConfig, action?.chatbot_step_action_id,
                {
                    ...action?.action_data,
                },
                {
                    updateType: "editExistingStepAction"
                }
            ); 
        }
    }

    const getIntentNameWithCondition = (intent: any) => {
        const conditionText = intent?.condition_group ? `(${getCustomVariableConditionText(customVariableList, intent?.condition_group?.custom_variable_conditions)})` : "";
        return `${intent?.intent_name} ${conditionText}`;
    }

    const handleDeleteAction = (action: any) => {
        if (!isCurrentViewVersionPublished(currentActiveStaticWorkflow)) {

            const deleteStepActionObj = {
                updateType: "deleteStepAction",
                stepIdToDelete: action.chatbot_step_action_id
            }
            onChangeCurrentActiveNodeConfig(nodes, currentActiveNodeConfig, action.chatbot_step_action_id, action.action_data, deleteStepActionObj);

            if (action.action_type.action_type_name == ACTION_TYPE_NAME["TEMPLATE"]) {
                deleteEdgesRelatedToStepAction(edges, action.chatbot_step_id);
            } else if (action.action_type.action_type_name == ACTION_TYPE_NAME["CONDITION"]) {

                const selectedConditionEdge = edges.find((edge: any) => edge.sourceHandle?.split("+")[0] == action?.action_data?.unique_id);

                if (selectedConditionEdge) { // Check, If this condition is connected with any node.
                    setUpdatedEdges({
                        actionType: "deleteEdge",
                        edgeToBeDeleted: selectedConditionEdge?.id
                    },
                        nodes,
                        edges
                    );

                    updateNodeFlow({
                        actionType: "deleteEdge",
                        edgeToBeDeleted: selectedConditionEdge?.id,
                        edgeData: selectedConditionEdge
                    },
                        nodes,
                        edges
                    )
                }
            }

            if (action.flag_saved_in_BE) {
                onBlurOfFallBackOfBtnVar(nodes, currentActiveNodeConfig, action.chatbot_step_action_id, action.action_data, deleteStepActionObj);
            }
        }
    }

    return (
        <>
            <Grid item className={styles.bodyFormComponents}>
                <Grid container direction={"column"} gap={2}>
                    {/* {triggerDataObject && triggerDataObject.function_name === "trigger" && selectedPointerEvent === "trigger" &&
                        <TriggerFormComponent
                            handleBodyTitle={handleBodyTitle} handleSelectFunctionTrigger={handleSelectFunctionTrigger} handleDyanmicTriggerData={handleDyanmicTriggerData} />
                    } */}

                    <DragDropContext onDragEnd={onDragEnd}>
                        <Droppable droppableId="steps-list">
                            {(provided) => (
                                <div {...provided.droppableProps} ref={provided.innerRef}>
                                    {nodes.find((node: any) => node.id == currentActiveNodeConfig.nodeId).data.filter((action: any) => action?.action_type).map((action: any, index: number) => {
                                        const lastIndex = nodes.find((node: any) => node.id == currentActiveNodeConfig.nodeId).data?.length - 1;
                                        return (
                                            <Draggable
                                                draggableId={JSON.stringify({
                                                    // id: action.chatbot_step_action_id.toString(),
                                                    // data: action.action_data,
                                                    id: index,
                                                    data: {},
                                                })}
                                                index={index}
                                                // key={action.chatbot_step_action_id} 
                                                key={index}
                                            >
                                                {(provided, snapshot) => (
                                                    <Grid
                                                        item
                                                        xs={12}
                                                        ref={index ==lastIndex ? bodyFormRef :  provided.innerRef}
                                                        {...provided.draggableProps}
                                                        className={globalStyles.fullwidth}
                                                        key={index}
                                                    >
                                                        <Grid container justifyContent={"space-between"} alignItems={"center"}>
                                                            <Grid item className={globalStyles.displayFlex}>
                                                                {/* <div {...provided.dragHandleProps} style={{ margin: "0 6px 0 0", cursor: "grab", display: "flex" }}>
                                                                    <DragIndicatorIcon sx={{ color: '#999' }} />
                                                                </div> */}
                                                                <span className={styles.stepsTextStyle}>Action {index + 1}</span>
                                                            </Grid> 
                                                            <Grid item>
                                                                <Grid container gap={2} alignItems={"center"}>

                                                                    {(action?.intents && action?.intents?.length == 0 && doesAllowToConfigureIntentForActionType(action?.action_type?.action_type_name)) &&
                                                                        <Grid item>
                                                                            <Grid container gap={1} alignItems={"center"} className={globalStyles.clickable} onClick={(e) => onClickOfAddIntent(action)}>
                                                                                <Grid item className={globalStyles.displayFlex}>
                                                                                    <IconsColor fillColor="blue" iconName="plus" height="15" width="15" />
                                                                                </Grid>
                                                                                <Grid item>
                                                                                    <Typography className={`${styles.addIntentText}`}>
                                                                                        Add Intent
                                                                                    </Typography>
                                                                                </Grid>
                                                                            </Grid>
                                                                        </Grid>
                                                                    }

                                                                    <Grid item 
                                                                        className={globalStyles.displayFlexStyle} 
                                                                        sx={{ cursor: isCurrentViewVersionPublished(currentActiveStaticWorkflow) ? "not-allowed" : "pointer", opacity: !isCurrentViewVersionPublished(currentActiveStaticWorkflow) ? "1" : "0.5" }} 
                                                                        onClick={() => handleDeleteAction(action)}
                                                                    >
                                                                        <IconsColor iconName="DeleteIcon" height="17" width="17" fillColor={greyColor} />
                                                                    </Grid>
                                                                </Grid>
                                                            </Grid>
                                                        </Grid>
                                                        <Grid item
                                                        // marginLeft={"25px"}
                                                        >
                                                            <Grid container direction={"column"} gap="7px">
                                                                {getComponentByAction(action.action_type.action_type_name, action.action_data, action)}
                                                            </Grid>
                                                        </Grid> 

                                                        {(action?.intents && action?.intents?.length > 0) && 
                                                            <Grid item mt={2} className={textStyles.templatesContainer}>
                                                                <Grid container direction={"column"} gap={"12px"} flexWrap={"nowrap"}> 
                                                                    <Grid item>
                                                                        <Grid container justifyContent={"space-between"} alignItems={"center"}>
                                                                            <Grid item className={`${styles.configuredIntentTitle}`}>
                                                                                Configured Intent
                                                                            </Grid>
                                                                            <Grid item className={`${globalStyles.clickable} ${globalStyles.displayFlexStyle}`}>
                                                                                <Grid container gap={"5px"}>
                                                                                    <Grid item onClick={() => onClickOfAddIntent(action)}>
                                                                                        <IconsColor iconName="plus" height="17" width="17" fillColor="blue" />
                                                                                    </Grid>
                                                                                    <Grid item onClick={() => deleteConfiguredIntent(action)}>
                                                                                        <IconsColor iconName="DeleteIcon" height="16" width="16" fillColor={greyColor} />
                                                                                    </Grid>
                                                                                </Grid>
                                                                            </Grid>
                                                                        </Grid>
                                                                    </Grid>

                                                                    <Grid item>
                                                                        <Grid container gap={"2px"}>
                                                                            {action?.intents?.map((intent: any) => {
                                                                                return (
                                                                                    <Grid item xs={12} className={`${styles.contentBlockSubHeadingStyle} ${styles.intentContentBlock}`}>
                                                                                        <Grid container gap={1} justifyContent={"space-between"} flexWrap={"nowrap"} alignItems={"center"}>
                                                                                            <Grid item className={`${globalStyles.tertiaryFontSize} ${globalStyles.wordBreakBreakWord}`}>
                                                                                                {getIntentNameWithCondition(intent)}
                                                                                            </Grid>
                                                                                            <Grid item>
                                                                                                <Grid container gap={"5px"} className={globalStyles.displayFlexStyle} flexWrap={"nowrap"}>
                                                                                                    <Grid item>
                                                                                                        <ModeEditIcon className={styles.editIntentIcon} onClick={() => onClickOfAddIntent(action, intent)} />
                                                                                                    </Grid>
                                                                                                    <Grid item className={`${globalStyles.clickable} ${globalStyles.displayFlexStyle}`} onClick={() => deleteConfiguredIntent(action, intent)}>
                                                                                                        <IconsColor iconName="DeleteIcon" height="16" width="16" fillColor={greyColor} />
                                                                                                    </Grid>
                                                                                                </Grid>
                                                                                            </Grid>
                                                                                        </Grid>
                                                                                    </Grid>
                                                                                );
                                                                            })}
                                                                        </Grid>
                                                                    </Grid>
                                                                </Grid>
                                                            </Grid>
                                                        }
                                                        {/* <ChatbotException flagActionLevel={true} actionID={action.chatbot_step_action_id} /> */}
                                                        <Divider className={styles.actionDivider} />
                                                    </Grid>
                                                )}
                                            </Draggable>
                                        )
                                    })}
                                    {provided.placeholder}
                                </div>
                            )}
                        </Droppable>
                    </DragDropContext>



                    {/* <Divider sx={{ opacity: "0.7", marginBlock: "10px" }} /> */}
                    {nodes.find((node: any) => node.id == currentActiveNodeConfig.nodeId).data.length > 0 &&
                        <Grid item>
                            {/* <ChatbotException 
                                flagActionLevel={true} 
                                actionID={nodes.find((node: any) => node.id == currentActiveNodeConfig.nodeId).data[0].chatbot_step_action_id} 
                            /> */} 
                            <ChatbotExceptionNew
                                flagStepLevel={true}
                                stepId={currentActiveNodeConfig.nodeId}
                            />
                        </Grid>
                    }

                    {isWhatsApp &&
                        <Grid item>
                            <SmartDelay
                                flagStepLevel={true} 
                                stepId={currentActiveNodeConfig.nodeId}
                            />
                        </Grid>
                    }

                    <Grid item>
                        <Grid container direction={"column"} gap={"10px"}>
                            <Grid item className={`${styles.contentBlockSubHeadingStyle} ${globalStyles.fullwidth}`}>
                                Add one of the content blocks:
                            </Grid>
                            <Grid item className={`${globalStyles.fullwidth}`}>
                                <NewContentBlocks bodyFormRef={bodyFormRef} />
                            </Grid>
                        </Grid>
                    </Grid>

                </Grid>
            </Grid>
            {flagIntentPopup && 
                <GlobalPopUp
                    open={flagIntentPopup}
                    onClose={() => { setFlagIntentPopup(false) }}
                    handleClose={() => { setFlagIntentPopup(false) }}
                    flagShowCloseIcon={true}
                    paperMinWidth={breakPoints.flagSmallScreen ? "300px" : "850px"}
                    paperMaxwidth={breakPoints.flagSmallScreen ? "710px" : "950px"}
                    // height='95%'
                    borderRadius='10px'
                    titlePadding='0px'
                    overflow="hidden"
                >
                    {/* <IntentPopup
                        setFlagIntentPopup={setFlagIntentPopup} 
                        selectedActionIntent={selectedActionIntent} 
                        onClickOfCancelIntent={onClickOfCancelIntent}
                    /> */} 

                    <IntentConfigurationPopup
                        setFlagIntentPopup={setFlagIntentPopup} 
                        selectedActionIntent={selectedActionIntent} 
                        selectedIntent={selectedIntent}
                    />
                </GlobalPopUp>
            }

            {flagUpdateThreadTagPopup && 
                <GlobalPopUp
                    open={flagUpdateThreadTagPopup}
                    handleClose={() => setFlagUpdateThreadTagPopup(false)}
                    onClose={() => setFlagUpdateThreadTagPopup(false)}
                    flagShowCloseIcon={true}
                    titlePadding='0px'
                    paperMinWidth={breakPoints?.flagSmallScreen ? "310px" : "700px"}
                    paperMaxwidth={breakPoints?.flagSmallScreen ? "610px" : "750px"}
                >
                    <CreateUpdateThreadTagPopup />
                </GlobalPopUp>
            }
        </>
    )
}

export default WorkflowFormBody
